import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import "../../Assets/CSS/Login.css";
import lms from "../../Assets/Images/rak-logo.png";
import { Link, useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa"; // For show/hide password icon
import loginBackground from '../../Assets/Images/login-background.png'
import LightText from "../../Assets/CSS/Text";
import toast from "react-hot-toast";
import { jwtDecode } from "jwt-decode";

function Login({ setIsAuthenticatedState }) {
  const [officeMail, setCompanyMailId] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false); // Toggle for password visibility
  const [errorMessage, setErrorMessage] = useState("");
  const [showPrompt, setShowPrompt] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    //console.log(process.env);


    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/auth/login`,
        {
          // companyMailId,
          officeMail,
          password,
        },
        {
          headers: {
            "Content-Type": "application/json", // Ensure JSON format
          },
          withCredentials: true, // Allows cookies or credentials (if required)
        }
      );

      console.log("Response:", response.data);
      const getTokenInfo = (token) => {
        try {
          const decoded = jwtDecode(token);
          console.log("Decoded Token:", decoded);

          // Fields available
          const empId = decoded.empId || null;
          const userName = decoded.userName || decoded.sub || null;
          const roles = decoded.roles || [];  // backend sets "roles" as an array
          const expiryTime = decoded.exp ? decoded.exp * 1000 : null; // exp claim is standard
          console.log("user Name.......", userName)
          return {
            empId, userName, roles, expiryTime

          };

        } catch (error) {
          console.error("Invalid token", error);
          return {};
        }
      };
      // Handle successful login
      // if (response.status === 200) {
      //   // const { empId, token, userName, tokenType, expiresIn } = response.data;

      //   const { token } = response.data;
      //   toast.success("login successfull. !")
      //   // Save token to localStorage immediately
      //   localStorage.setItem("token", token.trim());


      //   // const token = localStorage.getItem("token");
      //   const { empId, userName, tokenType, exp, roles } = getTokenInfo(token);

      //   // console.log(empId, userName, tokenType, expiresIn, roles);
      //   console.log("Employee ID:", empId);
      //   console.log("User Name:", userName);
      //   console.log("Roles:", roles);
      //   console.log("Token Expiry:", new Date(expiryTime).toISOString());

      //   // Log expiration info for debugging
      //   console.log("JWT Expiration (from API):", exp);

      //   // Save the token and expiry time to localStorage
      //   // const expiryTime = Date.now() + exp; // Assume jwtExpirationMs is in milliseconds
      //   const expiryTime = exp ? exp * 1000 : Date.now() + 3600 * 1000; // fallback 1h
      //   localStorage.setItem("tokenExpiry", expiryTime.toString());

      //   console.log("Calculated Expiry Time:", new Date(expiryTime).toISOString());
      //   localStorage.setItem("token", token.trim());
      //   localStorage.setItem("tokenExpiry", expiryTime.toString());
      //   // localStorage.setItem("roles", roles);
      //   localStorage.setItem("userName", userName);
      //   console.log("Token:", `${tokenType} ${token}`);
      //   console.log("Employee ID:", empId);

      //   // Set a timeout to clear the token when it expires
      //   setTimeout(() => {
      //     logout();
      //   }, exp);
      //   // Redirect based on role (decoded from token directly)
      //   const decoded = jwtDecode(token);
      //   console.log("Decoded Token Payload:", decoded);

      //   const role = roles.length > 0 ? roles[0] : null;

      //   if (decoded.exp) {
      //     const expiryTime = decoded.exp * 1000; // convert to ms
      //     console.log("JWT Expiration (from token):", new Date(expiryTime).toISOString());
      //     localStorage.setItem("tokenExpiry", expiryTime.toString());
      //   }


      //   // Redirect based on roles
      //   // if (roles.includes("ROLE_ADMIN")) {
      //   //   console.log("Navigating to Admin Dashboard");
      //   //   navigate("/dashboard");
      //   // }
      //   // else if (roles.includes("ROLE_EMP")) {
      //   //   console.log("Navigating to Employee Dashboard");
      //   //   navigate("/my-attendence");
      //   // } else if (roles.includes("ROLE_MANAGER")) {
      //   //   console.log("Navigating to Manager Dashboard");
      //   //   navigate("/manager/dashboard");
      //   // } 
      // }
      if (response.status === 200) {
        const { token } = response.data;
        localStorage.setItem("token", token);
        const { roles, exp } = getTokenInfo(token);
        const expiryTime = exp * 1000;
        localStorage.setItem("tokenExpiry", expiryTime);

        toast.success("Login successful!");
        if (setIsAuthenticatedState) setIsAuthenticatedState(true);
        // Navigate immediately based on role
        // if (roles.includes("ROLE_ADMIN")) navigate("/admin-dashboard");
        // else if (roles.includes("ROLE_EMP")) navigate("/employee-dashboard");
        // else if (roles.includes("ROLE_MANAGER")) navigate("/admin-timesheet");
        // else navigate("/");

      }
      else {
        setErrorMessage("Invalid credentials.");
      }
    } catch (error) {
      //console.error("Login error:", error.response ? error.response.data : error);
      setErrorMessage(
        error.response?.data?.message || "Error logging in. Please try again."
      );
    }
  };

  const logout = () => {
    // Clear the token and expiry time from localStorage
    localStorage.clear();
    localStorage.removeItem("token");
    localStorage.removeItem("tokenExpiry");
    console.log("User logged out due to token expiry.");
    alert("Session expired. Please log in again.");
    navigate("/"); // Redirect to login page
  };

  // Automatically check token expiry on component mount
  useEffect(() => {
    const expiryTime = localStorage.getItem("tokenExpiry");
    if (expiryTime) {
      const timeLeft = expiryTime - Date.now();
      console.log("Time Left (ms):", timeLeft);

      if (timeLeft <= 0) {
        logout(); // Token is already expired
      } else {
        // Set a timeout to logout when the token expires
        setTimeout(() => {
          logout();
        }, timeLeft);
      }
    }
  }, []);

  return (
    <div
      className="vh-100 d-flex flex-column">
      <div
        className=" w-100"
        style={{
          flex: 1,
          height: "50%",
          backgroundImage: `url(${loginBackground})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />
      <div
        style={{
          flex: 1,
          height: "50%",
          backgroundColor: "#f8f9fa",
        }}
        className="d-flex align-items-end "
      >
        <div className="container mb-4 ">
          <div className="row justify-content-center">
            <div className="col-11 col-sm-10 col-md-8 col-lg-5 col-xl-4 bg-white border rounded-2"
              style={{
                boxShadow: '0px 4px 14px 0px #0000001A'
              }}>
              <div className="text-center">
                <img
                  src={lms}
                  className="img-fluid mb-1 mt-3 text-center border"
                  style={{ width: "300px", height: "auto" }}
                  alt="Logo"
                />
                <div className="p-3">
                  <form onSubmit={handleLogin} className="loginform">
                    <h4 className="text-start text-black">Sign In</h4>
                    <div className="form-group d-grid gap-2 mt-4">
                      <label className="text-start" style={LightText}>Email ID</label>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Enter email"
                        value={officeMail}
                        onChange={(e) => setCompanyMailId(e.target.value)}
                        required
                      />
                    </div>
                    <div className="form-group d-grid gap-2 mt-3 position-relative">
                      <label className="text-start" style={LightText}>Password</label>
                      <input
                        type={showPassword ? "text" : "password"}
                        className="form-control"
                        placeholder="Enter password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                      />
                      <span
                        className="position-absolute"
                        style={{
                          top: "70%",
                          right: "10px",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                        }}
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                      </span>
                    </div>
                    <div className="my-1 pt-1 text-end">
                      <Link
                        to="/forgotPassword"
                        className="text-decoration-none"
                        style={{ color: "#909090" }}
                      >
                        <span className="forgot-text">Forgot Password?</span>
                      </Link>
                    </div>
                    {errorMessage && (
                      <div className="alert alert-danger mt-2">{errorMessage}</div>
                    )}
                    <button
                      type="submit"
                      className="btn text-white w-100 login-btn px-2 my-2 btn-block mt-3"
                      style={{ background: "#00AFEF" }}
                    >
                      Login
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
